var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPause(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "63px",
    height: "63px",
    viewBox: "0 0 63 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPause") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Account-Settings",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Account-Settings------Pause-My-account-",
    transform: "translate(-156.000000, -172.000000)",
    fill: "#7BCB45",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    transform: "translate(156.000000, 172.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7,62.3 C14.5791728,62.3 0.7,48.4208272 0.7,31.3 C0.7,14.1791728 14.5791728,0.3 31.7,0.3 C48.8208272,0.3 62.7,14.1791728 62.7,31.3 C62.7,48.4208272 48.8208272,62.3 31.7,62.3 Z M31.7,59.3 C47.163973,59.3 59.7,46.763973 59.7,31.3 C59.7,15.836027 47.163973,3.3 31.7,3.3 C16.236027,3.3 3.7,15.836027 3.7,31.3 C3.7,46.763973 16.236027,59.3 31.7,59.3 Z M24.7,18.8 L25.7,18.8 C26.5284271,18.8 27.2,19.4715729 27.2,20.3 L27.2,41.3 C27.2,42.1284271 26.5284271,42.8 25.7,42.8 L24.7,42.8 C23.8715729,42.8 23.2,42.1284271 23.2,41.3 L23.2,20.3 C23.2,19.4715729 23.8715729,18.8 24.7,18.8 Z M38.7,18.8 L39.7,18.8 C40.5284271,18.8 41.2,19.4715729 41.2,20.3 L41.2,41.3 C41.2,42.1284271 40.5284271,42.8 39.7,42.8 L38.7,42.8 C37.8715729,42.8 37.2,42.1284271 37.2,41.3 L37.2,20.3 C37.2,19.4715729 37.8715729,18.8 38.7,18.8 Z",
    id: "icPause"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPause);
export default __webpack_public_path__ + "static/media/icPause.20c674c7856313a54b0fe34e7ac3aa53.svg";
export { ForwardRef as ReactComponent };